import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

type Props = Omit<React.ComponentProps<typeof Button>, 'onClick'> & {
	/** Injected by `ShareAction`: runs the copy and the share action's side effects. */
	onClick?: () => void;
	/** Usually `press` from `useCopyLinkConfirmation`, which decides whether the share action runs. */
	onPress: (share: (() => void) | undefined) => void;
};

/**
 * Copy-link button to render as a `ShareAction` child, so its presses go through `useCopyLinkConfirmation`. Define
 * it outside the component rendering it so the button keeps its identity (and focus) across the copied state.
 */
export const GuardedCopyButton = ({ onClick, onPress, ...props }: Props): React.JSX.Element => (
	<Button {...props} onClick={() => onPress(onClick)} />
);
